import React, { FC, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import './MobileNavbar.css';
import logo from '../../../assets/OneLife_Mascot_Trimmed.png';
import svgLogo from '../../../assets/OneLife_Mascot.svg';
import textLogo from '../../../assets/OneLife_Wordmark.svg';

interface NavLinkItem {
    name: string;
    path: string;
}

interface Props {
    navLinks: NavLinkItem[];
}



const MobileNavbar: FC<Props> = ({ navLinks }) => {

    const navigate = useNavigate()
    const goHome = () => {
        setDrawerOpen(false);
        navigate('/')
    }
    
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    return (
        <nav className="mobile navbar">
            <div className="navbar-elements">
                <div className="mainNav" >
                    <img src={svgLogo} alt="Logo" className="LogoImg" onClick={goHome} />
                    <img src={textLogo} alt="LogoText" className="LogoText" />
                    <button className="HamburgerMenu" onClick={toggleDrawer}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" /></svg>
                    </button>
                </div>
                <div className="navDrawer" data-active={drawerOpen}>
                    <ul className="nav-links">
                        {navLinks.map((link: NavLinkItem) => (
                            <li key={link.path}>
                                <NavLink to={link.path} onClick={toggleDrawer} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                                    {link.name}
                                </NavLink>
                            </li>
                        ))}
                        
                        <li>
                            <button className="application-btn nav-button"onClick={()=>{navigate('/loan-application-form');toggleDrawer()}} >Start Application</button>
                        </li>
                        <li>
                            <button className="subscribe-btn nav-button" onClick={()=>{navigate('/subscription-agreement-application');toggleDrawer()}}>Subscribe to Us</button>
                        </li>
                    </ul>
                    <div className="drawerOverlay" onClick={toggleDrawer} />
                </div>

            </div>
        </nav>
    );
};

export default MobileNavbar;